var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletedCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0498 17.8496L20.3498 17.1496V7.89961H11.0998L10.9498 7.74961V3.89961H7.0498L6.3498 3.19961H11.6498V7.19961H21.0498V17.8496ZM22.1498 22.4496L19.5998 19.8996H2.9498V3.24961L1.2998 1.59961L1.7998 1.09961L22.6498 21.9496L22.1498 22.4496ZM3.6498 19.1996H6.9498V15.8996H3.6498V19.1996ZM3.6498 15.1996H6.9498V11.8996H3.6498V15.1996ZM3.6498 11.1996H6.9498V7.89961H3.6498V11.1996ZM7.6498 19.1996H10.9498V15.8996H7.6498V19.1996ZM7.6498 15.1996H10.9498V11.8996H7.6498V15.1996ZM11.6498 19.1996H18.8998L15.5998 15.8996H11.6498V19.1996ZM17.3498 11.8996H16.6498V11.1996H17.3498V11.8996Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletedCompanies);
export default __webpack_public_path__ + "static/media/deleted-companies.bbf424002d45d5b75f5721b38499b9a9.svg";
export { ForwardRef as ReactComponent };